import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './spinner.sass'

const Spinner = ({ className, text, isCentered, noOffset, isSmall }) => (
  <div
    className={classNames('spinner', className, {
      '--centered': isCentered,
      '--no-offset': noOffset,
      '--small': isSmall,
    })}
  >
    {isSmall ? (
      <svg
        className="spinner__inner --small"
        width="32px"
        height="32px"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className="spinner__path --small"
          fill="none"
          strokeWidth="2"
          cx="16"
          cy="16"
          r="12"
        />
      </svg>
    ) : (
      <>
        <svg
          className="spinner__outer"
          width="66px"
          height="66px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle className="spinner__path" fill="none" strokeWidth="2" cx="33" cy="33" r="30" />
        </svg>

        <svg
          className="spinner__inner"
          width="66px"
          height="66px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle className="spinner__path" fill="none" strokeWidth="4" cx="33" cy="33" r="24" />
        </svg>

        {text && <div className="spinner__text">{text}</div>}
      </>
    )}
  </div>
)

Spinner.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  noOffset: PropTypes.bool,
  isCentered: PropTypes.bool,
  isSmall: PropTypes.bool,
}

Spinner.defaultProps = {
  className: '',
  text: null,
  isCentered: false,
  noOffset: false,
  isSmall: false,
}

export default Spinner
